import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/auth`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ptl/auth/auth-mgmt`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0104010q: `${BASE.path}/osci0104010q`, // Auth Management List                    !== 권한 관리 목록 ==!
    osci0104011s: `${BASE.path}/osci0104011s`, // Auth Management Registration            !== 권한 관리 등록 ==!
    osci0104012s: `${BASE.path}/osci0104012s`, // Auth Management Details                 !== 권한 관리 상세 ==!
};

export const PGEUIDS = {
    osci0104010q: "osci0104010q",
    osci0104011s: "osci0104011s",
    osci0104012s: "osci0104012s",
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Auth Management List !== 권한 관리 목록 ==!
    getAuthList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) });
    },
    // Auth Management Detail !== 권한 관리 상세 ==!
    getAuthDtl: (data: any) =>
        api.get(`${BASE.api}/${data.authId}`, {
            params: comnUtils.toGetParams({ bsopClsfCd: data.bsopClsfCd, ptlTpCd: data.ptlTpCd }),
        }),
    // Create Auth Management !== 권한 관리 등록 ==!
    createAuthDtl: (data: any) => api.post(`${BASE.api}`, { ...data }),
    // Modify Auth Management !== 권한 관리 수정 ==!
    updateAuthDtl: (data: any) => api.put(`${BASE.api}/${data.authId}`, { ...data }),
    // Delete Auth Management !== 권한 관리 삭제 ==!
    deleteAuthDtl: (data: any) =>
        api.delete(`${BASE.api}/${data.authId}`, {
            params: comnUtils.toGetParams({ bsopClsfCd: data.bsopClsfCd, ptlTpCd: data.ptlTpCd }),
        }),

    // Select Authority user mapping !== 권한 사용자 매핑 여부 ==!
    getAuthMapInfo: (data: any) =>
        api.get(`${BASE.api}/map`, { params: comnUtils.toGetParams({ authId: data.authId, ptlTpCd: data.ptlTpCd }) }),
};

export const SF_AUTH_MGMT_SRCH: TFormSchema = {
    id: "form_authMgmtSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            select: false,
            excludes: ["COM"],
            editType: "both",
            defaultValue: "OSC",
            edit: false,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            select: false,
            excludes: ["B", "I", "E"],
            editType: "both",
            defaultValue: "O",
            edit: false,
        },
        authId: { type: "text", label: "L_AUTH_ID" },
        authNm: { type: "text", label: "L_AUTH_NM" },
    },
};

export const SF_AUTH_MGMT_DTL: TFormSchema = {
    id: "form_authMgmtDtl",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            excludes: ["COM"],
            defaultValue: "OSC",
            edit: false,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "I", "E"],
            defaultValue: "O",
            edit: false,
        },
        authId: { type: "text", label: "L_AUTH_ID" },
        authNmKO: { required: true, type: "text", label: "L_AUTH_NM_KO" },
        authNmEN: { required: true, type: "text", label: "L_AUTH_NM_EN" },
        authNmTZ: { required: true, type: "text", label: "L_AUTH_NM_TZ" },
        authDescKO: { required: true, type: "text", label: "L_AUTH_DESC_KO" },
        authDescEN: { required: true, type: "text", label: "L_AUTH_DESC_EN" },
        authDescTZ: { required: true, type: "text", label: "L_AUTH_DESC_TZ" },
    },
};

export const SG_AUTH_MGMT_LIST: TGridSchema = {
    id: "grid_authMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "20%" }] },
        { cells: [{ header: "L_AUTH", binding: "authNm", width: "*" }] },
        { cells: [{ header: "L_DESC", binding: "authDesc", width: "*" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "*" }], show: false },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCd", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "authId" }] },
        { cells: [{ binding: "authNm", align: "left" }] },
        { cells: [{ binding: "authDesc", align: "left" }] },
        { cells: [{ binding: "bsopClsfCd" }] },
        { cells: [{ binding: "ptlTpCd" }] },
    ],
};
export const SG_AUTH_LANG_LIST: TGridSchema = {
    id: "grid_authLangList",
    head: [
        { cells: [{ binding: "authId" }] },
        { cells: [{ binding: "authId" }] },
        { cells: [{ binding: "authNm" }] },
        { cells: [{ binding: "authDesc" }] },
    ],
    body: [
        { cells: [{ binding: "authId" }] },
        { cells: [{ binding: "authNm" }] },
        { cells: [{ binding: "authDesc" }] },
    ],
};
